import { LOCATION_ACTION_TYPES } from '../actions/location.actions';

const initialState = {
  locationData: {},
  processing: false,
};

export default function (state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case LOCATION_ACTION_TYPES.LOCATION_SET_DATA_BY_KEY:
      return { ...state, [payload.stateKeyForDataSaving]: { ...payload.data } };
    case LOCATION_ACTION_TYPES.LOCATION_SET_LINK_BY_KEY:
      return { ...state, [payload.stateKeyForLink]: payload.data };
    case LOCATION_ACTION_TYPES.LOCATION_CHANGE_PROCESSING:
      return {
        ...state,
        processing: payload,
      };
    default:
      return state;
  }
}
